module.exports = __webpack_public_path__ + "img/logo4.7d518810.png";